module.exports = __webpack_public_path__ + "static/media/facebook.529e49a7.svg";